var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.83333 13.3333H2.5C2.05797 13.3333 1.63405 13.1577 1.32149 12.8452C1.00893 12.5326 0.833333 12.1087 0.833333 11.6667V9.91333C0.833109 9.69553 0.875576 9.4798 0.958333 9.27833L3.53833 3.01667C3.60107 2.86396 3.70775 2.73333 3.84483 2.64134C3.98192 2.54936 4.14324 2.50016 4.30833 2.5H18.3333C18.5543 2.5 18.7663 2.5878 18.9226 2.74408C19.0789 2.90036 19.1667 3.11232 19.1667 3.33333V11.6667C19.1667 11.8877 19.0789 12.0996 18.9226 12.2559C18.7663 12.4122 18.5543 12.5 18.3333 12.5H15.4317C15.2983 12.5 15.1668 12.532 15.0483 12.5933C14.9298 12.6546 14.8278 12.7435 14.7508 12.8525L10.2067 19.2908C10.1492 19.3722 10.0645 19.4304 9.96789 19.4547C9.87126 19.479 9.76913 19.4679 9.68 19.4233L8.16833 18.6667C7.74292 18.454 7.40306 18.1022 7.20522 17.6697C7.00739 17.2372 6.9635 16.7501 7.08083 16.2892L7.83333 13.3333ZM14.1667 11.1767V4.16667H4.86667L2.5 9.91333V11.6667H7.83333C8.08717 11.6667 8.33764 11.7247 8.56564 11.8363C8.79364 11.9479 8.99315 12.11 9.14894 12.3104C9.30473 12.5108 9.41268 12.7442 9.46457 12.9926C9.51646 13.2411 9.5109 13.4982 9.44833 13.7442L8.69583 16.7008C8.67228 16.7931 8.68102 16.8906 8.72059 16.9771C8.76016 17.0637 8.82818 17.1341 8.91333 17.1767L9.46417 17.4517L13.3892 11.8917C13.5975 11.5967 13.8642 11.355 14.1667 11.1767V11.1767ZM15.8333 10.8333H17.5V4.16667H15.8333V10.8333Z",
    fill: "#DF3B25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default ForwardRef;